import { createAction } from '@reduxjs/toolkit';
import { createSlice } from 'lib';
import { HighlightState, S } from 'types';

const name = 'details/highlight';

/** The asset / user the mouse is over in one of the lists, so the same person lights up in all of them. */
export const setHighlightedPerson = createAction<string | null>(`${name}/setHighlightedPerson`);

export const highlight = createSlice<HighlightState, typeof name>({
  name,
  initialState: { personId: null },
  extraReducers: (builder) => builder
    .addCase(setHighlightedPerson, (state, action) => {

      state.personId = action.payload;

    }),
});

export const highlightedPersonSelector: S<string | null> = (state) => state.details.highlight.personId;
